import React from "react";
import "../styles/About.css";
import { FaRegLightbulb, FaUsers, FaClock, FaBrain, FaCodeBranch, FaSync } from 'react-icons/fa';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-header">
        <span className="mono-label">04/</span>
        <h1>About</h1>
      </div>
      
      <div className="about-grid">
        <div className="about-section intro-section">
          <div className="section-header">
            <span className="section-index">01</span>
            <h2>Introduction</h2>
          </div>
          <div className="section-content">
            <p>
              Full-stack software engineer focused on building scalable, user-centered web
              applications. Comfortable across React, JavaScript, TypeScript, Node.js,
              Spring, databases, and AWS-backed systems.
            </p>
            <p>
              Experience spans lead intern work at Silver Spark Studios, freelance delivery for
              major brands, and product-style builds such as{" "}
              <a href="https://rollplan.app" target="_blank" rel="noopener noreferrer">
                RollPlan
              </a>
              , a full-stack BJJ gym platform (
              <a href="https://github.com/PkTaz/RollPlan" target="_blank" rel="noopener noreferrer">
                source
              </a>
              ), alongside AI tooling and enterprise CRM design.
            </p>
          </div>
        </div>
        
        <div className="about-section background-section">
          <div className="section-header">
            <span className="section-index">02</span>
            <h2>Background</h2>
          </div>
          <div className="section-content">
            <p>
              B.S. in Software Engineering from Western Governors University (Dec 2025) and
              beginning an M.S. in AI Engineering, with deep coursework in back-end and front-end engineering.
            </p>
            <div className="highlight-text">
              <span>Balancing technical expertise with real-world application.</span>
            </div>
          </div>
        </div>
        
        <div className="about-section experience-section">
          <div className="section-header">
            <span className="section-index">03</span>
            <h2>Experience</h2>
          </div>
          <div className="section-content">
            <div className="experience-item">
              <h3>Lead Software Engineer Intern</h3>
              <p className="experience-period">Silver Spark Studios · May 2025—Oct 2025</p>
              <p>
                Lead developer planning and shipping full-stack web apps: scope, timelines,
                architecture, API integrations, and mentoring juniors on sprints and workflow.
              </p>
            </div>
            <div className="experience-item">
              <h3>Freelance Full-Stack Developer</h3>
              <p className="experience-period">Will Chapman · Jan 2023—May 2025</p>
              <p>
                AI color tooling, conversion-focused UX for brands like Gymshark and Detroit Lions,
                and this React portfolio with dynamic UI and API-driven features.
              </p>
            </div>
          </div>
        </div>
        
        <div className="about-section skills-section">
          <div className="section-header">
            <span className="section-index">04</span>
            <h2>Core Skills</h2>
          </div>
          <div className="skills-grid">
            <div className="skill-card">
              <FaRegLightbulb className="skill-icon" />
              <h3>Problem Solving</h3>
              <p>Breaking down complex problems to find elegant solutions.</p>
            </div>
            <div className="skill-card">
              <FaUsers className="skill-icon" />
              <h3>Communication</h3>
              <p>Translating technical concepts for non-technical stakeholders.</p>
            </div>
            <div className="skill-card">
              <FaClock className="skill-icon" />
              <h3>Time Management</h3>
              <p>Managing priorities and meeting deadlines efficiently.</p>
            </div>
            <div className="skill-card">
              <FaBrain className="skill-icon" />
              <h3>Critical Thinking</h3>
              <p>Analysis-driven decision making based on evidence.</p>
            </div>
            <div className="skill-card">
              <FaCodeBranch className="skill-icon" />
              <h3>Collaboration</h3>
              <p>Working effectively in team environments to achieve goals.</p>
            </div>
            <div className="skill-card">
              <FaSync className="skill-icon" />
              <h3>Agile</h3>
              <p>Iterating with feedback, sprints, and clear delivery goals.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
